export { default as DocumentationRequestEmailEditTemplate } from './DocumentationRequestEmailEditTemplate';
